jQuery(document).ready(function ($) {
    var current_id = $('.actual-bonus').attr('id');
    var timeout = null;

    // button feature
    $(document).on('click', 'button.filter_inputs', function(){
        var option = $(this).attr('name');
        var other_id = $(this).attr('id');
        compare_casino_select(option, current_id, other_id);
    });

    // search feature
    $('.casino_search input').keyup(function(){
        var input = $(this).val();
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            compare_casino_search(input, current_id);
        }, 500);
    });

    // load the carousel for the compare feature
    $('.main-carousel').flickity( {
        cellAlign: 'left',
        contain: true,
        pageDots: false
    });

    // button feature
    function compare_casino_select(option, current_id, other_id){
        $.ajax({
            url: ajaxCompareCasinos.ajaxUrl,
            type: 'post',
            data: {
                action: 'ajax_compare_casinos',
                option: option,
                current_id: current_id,
                other_id: other_id,
                security: ajaxCompareCasinos.security
            },
            success: function(response){
                response = JSON.parse(response);
                var cards = response.cards;
                var cells = $('.main-carousel').find('.compare-bonus-card');

                // loop through the compare-caisno feature and change bonus/freespins variables
                for(var i=0; i< 5; i++){
                    $('.main-carousel').flickity('remove', cells[i]);
                    // insert cards if there are remaining cards left
                    if(typeof(cards[i]) !== 'undefined'){
                        $('.main-carousel').flickity('insert', $(cards[i]), i);
                        $('.main-carousel').flickity('select', 0);
                    }
                }
            }
        })
    }

    // search feature
    function compare_casino_search(search_casino, current_id){
        $.ajax({
            url: ajaxCompareCasinos.ajaxUrl,
            type: 'post',
            data: {
                action: 'ajax_search_compare_casinos',
                current_id: current_id,
                search_casino: search_casino,
                security: ajaxCompareCasinos.security
            },
            success: function(response){
                response = JSON.parse(response);
                var search_results = response.search_results;
                var current_search_results = $('.casino_search_results').children();

                // loop through and display each search result
                for(var i=0; i< 3; i++){
                    // remove if exists
                    if(typeof(current_search_results[i]) != 'undefined'){
                        $(current_search_results[i]).remove();
                    }
                    $('.casino_search_results').append($(search_results[i]));
                }
            }
        })
    }
});
